import type { Metadata, Viewport } from 'next'

const OG_TITLE = 'Luxury Day Spa and Massage Thailand | Oasis Spa Thailand'
const OG_DESCRIPTION =
  'Oasis Spa is one of the best luxury day spa, Oasis Spa provide the spa experience by combining Lanna secrets with advanced discoveries in beauty and wellness.'
const OG_IMAGE = '/static/images/oasis-spa.png'

export const metadata: Metadata = {
  metadataBase: new URL(process.env.NEXT_PUBLIC_BASE_URL ?? 'https://www.oasisspa.net'),
  title: OG_TITLE,
  keywords:
    'spa,Oasis spa,spa near me,thai massage near me,day spa,the oasis spa thailand,oasis spas,best spa near me,best thai massage near me,luxurious spa,best thai massage,luxury thai spa,body massage,spa near me,day spa near me,thai spa near me,day spa near me,oasis spa thailand,the oasis spa,spa booking online,best spa,treatment,best thai spa near me,book online spa,luxury spa,oasis day spa,spa for kids,relax,Spa treatment',
  description: OG_DESCRIPTION,
  robots: { index: true, follow: true },
  icons: [
    { rel: 'icon', url: '/static/favicon-32x32.png', type: 'image/png', sizes: '32x32' },
    { rel: 'apple-touch-icon', url: '/static/apple-touch-icon.png', type: 'image/png' }
  ],
  manifest: '/manifest.webmanifest',
  openGraph: {
    type: 'website',
    siteName: 'Oasis Spa',
    title: OG_TITLE,
    description: OG_DESCRIPTION,
    images: [{ url: OG_IMAGE, alt: 'Oasis Spa Thailand' }]
  },
  twitter: {
    card: 'summary_large_image', // Enlarge mode in telegram
    title: OG_TITLE,
    description: OG_DESCRIPTION,
    images: [OG_IMAGE]
  }
}

export const viewport: Viewport = {
  width: 'device-width',
  initialScale: 1,
  colorScheme: 'only light',
  themeColor: [
    { media: '(prefers-color-scheme: dark)', color: '#040404' },
    { media: '(prefers-color-scheme: light)', color: '#fef9f1' }
  ]
}
